import { Combobox as ComboboxPrimitive } from '@base-ui/react/combobox';

import { cn } from '@/lib/utils';

export type ComboboxListProps = ComboboxPrimitive.List.Props;

const ComboboxList = ({ className, children, ...props }: ComboboxListProps) => {
  return (
    <ComboboxPrimitive.List
      data-slot="combobox-list"
      className={cn(
        'no-scrollbar max-h-[min(calc(--spacing(72)-(--spacing(9))),calc(var(--available-height)-(--spacing(9))))] scroll-py-1 overflow-y-auto overscroll-contain p-1 data-empty:p-0',
        className,
      )}
      {...props}
    >
      {children}
    </ComboboxPrimitive.List>
  );
};

export default ComboboxList;
